import styled from 'styled-components';

export const ProgressBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;
  gap: 0.5rem;
`;

export const ProgressStep = styled.div<{
  $active: boolean;
  $completed: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 0.875rem;
  font-weight: 600;
  border: 2px solid
    ${({ $active, $completed, theme }) =>
      $active || $completed ? theme.colors?.primary || '#0078d4' : '#e1e1e1'};
  background-color: ${({ $active, $completed, theme }) =>
    $active
      ? theme.colors?.primary || '#0078d4'
      : $completed
        ? '#e3f2fd'
        : 'transparent'};
  color: ${({ $active, $completed, theme }) =>
    $active ? 'white' : $completed ? theme.colors?.primary || '#0078d4' : '#999'};
`;

export const ProgressConnector = styled.div<{ $active: boolean }>`
  width: 40px;
  height: 2px;
  background-color: ${({ $active, theme }) =>
    $active ? theme.colors?.primary || '#0078d4' : '#e1e1e1'};
`;
